import { attr, FASTElement, html } from '@microsoft/fast-element';
import { NatGenDesignSystem } from '../../natgen-design-system';
import { badgeStyles, BadgeVariant, BadgeColor, IBadgeStyles } from './badge.styles';

export type { BadgeVariant, BadgeColor };

/**
 * @element natgen-badge
 */
export class NatGenBadge extends FASTElement implements IBadgeStyles {
    /**
     * The visual style of the badge.
     *
     * @public
     * @remarks
     * HTML Attribute: variant
     */
    @attr
    public variant: BadgeVariant;

    /**
     * The colour palette of the badge.
     *
     * @public
     * @remarks
     * HTML Attribute: color
     */
    @attr
    public color: BadgeColor;

    public connectedCallback(): void {
        this.variant = this.variant || 'filled';
        this.color = this.color || 'neutral';
        super.connectedCallback();
    }
}

export const natGenBadgeDefinition = NatGenBadge.compose({
    name: `${NatGenDesignSystem.prefix}-badge`,
    template: html<NatGenBadge>`
        <template>
            <slot></slot>
        </template>
    `,
    styles: badgeStyles,
});
